<template>
  <div
      :style="{
        'width': percent + '%',
        'height': height,
        'background-color': canSuccess ? color : failedColor,
        'opacity': show ? 1 : 0
      }"
      class="PROGRESS"/>
</template>

<script>
export default {
  name: 'progress-bar',
  data () {
    return {
      percent: 0,
      show: false,
      canSuccess: true,
      duration: 3000,
      height: '2px',
      color: '#0275d8',
      failedColor: '#d9534f',
    };
  },
  methods: {
    $timeout: (callback, time) => {
      return setTimeout(callback, time);
    },
    $interval: (callback, time) => {
      return setInterval(callback, time);
    },
    $clearInterval: (timer) => {
      return clearInterval(timer);
    },
    start () {
      return new Promise((resolve) => {
        this.show = true;
        this.canSuccess = true;
        if (this._timer) {
          this.$clearInterval(this._timer);
          this.percent = 0;
        }
        this._cut = 10000 / Math.floor(this.duration);
        this._timer = this.$interval(() => {
          this.increase(this._cut * Math.random());
          if (this.percent > 95) {
            this.finish();
          }
          resolve(this);
        }, 100);
      });
    },
    set (num) {
      this.show = true;
      this.canSuccess = true;
      this.percent = Math.floor(num);
      return this;
    },
    get () {
      return Math.floor(this.percent);
    },
    increase (num) {
      this.percent = this.percent + Math.floor(num);
      return this;
    },
    decrease (num) {
      this.percent = this.percent - Math.floor(num);
      return this;
    },
    finish () {
      this.percent = 100;
      return this.hide();
    },
    pause () {
      this.$clearInterval(this._timer);
      return this;
    },
    hide () {
      return new Promise((resolve) => {
        this.$clearInterval(this._timer);
        this._timer = null;
        this.$timeout(() => {
          this.show = false;
          this.$nextTick(() => {
            this.$timeout(() => {
              this.percent = 0;
              resolve(this);
            }, 200);
          });
        }, 500);
      });
    },
    fail () {
      this.canSuccess = false;
      return this;
    },
  },
};
</script>

<style scoped>
.PROGRESS {
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  height: 2px;
  width: 0%;
  transition: width 0.2s, opacity 0.4s;
  opacity: 1;
  background-color: #efc14e;
  z-index: 999999;
}
</style>
